import type { SanityCaseStudyMetadata } from "@ouster/shared";
import { IntroDetailsBlockView } from "~/features/blocks/inventory/intro-details";
import { SanityRichText } from "~/features/sanity/rich-text";
import { buildCaseStudyIntroRows } from "./intro-details";
type Props = {
  metadata?: SanityCaseStudyMetadata | null;
};

/** Case-study Details live on the document rather than in its page builder. */
export function SanityCaseStudyIntro({
  metadata
}: Props) {
  const rows = buildCaseStudyIntroRows(metadata);
  if (!rows.length) return null;
  return <IntroDetailsBlockView details={rows} headline={metadata?.introHeadline} mode="light" text={metadata?.introText?.length ? <SanityRichText value={metadata.introText} /> : undefined} theme="white" />;
}